import React, { PureComponent } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { TransitionChildren } from './styles';

export default class LayoutAppear extends PureComponent {
    render() {
        const { children } = this.props;
        return (
            <ReactCSSTransitionGroup
                transitionName="layoutAppear"
                transitionAppear
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
                component="div"
            >
                <TransitionChildren>{children}</TransitionChildren>
            </ReactCSSTransitionGroup>
        );
    }
}
